import type { AuthUser } from '@/shared/types/auth';

const IDENTITY_KEYS = [
  'firstName',
  'lastName',
  'name',
  'email',
  'role',
  'mobileNumber',
  'mobileCountryCode',
] as const;

function isUsableProfilePic(value: unknown): boolean {
  if (!value) return false;
  if (typeof value === 'object') {
    const url = (value as { url?: unknown }).url;
    return typeof url === 'string' && url.trim().length > 0;
  }
  return typeof value === 'string' && /^https?:\/\//i.test(value.trim());
}

/** Map a profile/update payload onto the persisted auth user (never a raw media id). */
export function toAuthUserPatch(
  source: Record<string, unknown> | null | undefined,
): Partial<AuthUser> {
  if (!source) return {};

  const patch: Partial<AuthUser> = {};
  for (const key of IDENTITY_KEYS) {
    const value = source[key];
    if (value !== undefined && value !== null) {
      (patch as Record<string, unknown>)[key] = value;
    }
  }

  if (isUsableProfilePic(source.profilePic)) {
    patch.profilePic = source.profilePic;
  }

  return patch;
}
